<template>
  <van-pull-refresh
    class="other_page"
    v-model="isLoading"
    success-text="刷新成功"
    @refresh="onRefresh"
    v-swipeup="(e) => vueTouch('上滑', e)"
  >
    <div class="offical_trends" v-if="tops.length > 0">
      <ul>
        <li
          class="clear"
          v-for="item in tops"
          :key="item.id"
          @click="detailClick(item.id)"
        >
          <span>{{ item.topicType }}</span>
          <p>{{ item.title }}</p>
        </li>
        <!-- <li class="clear">
            <span>资讯</span>
            <p>【龙之国物语】</p>
          </li> -->
      </ul>
    </div>
    <!-- 用于检测距离的盒子 -->
    <div class="offical_trends offical_trends_1" v-else></div>
    <!-- 筛选条件 -->
    <div class="commonBg"></div>
    <div class="conditions clear">
      <p>筛选条件</p>
      <div class="conditons_right" @click="show = true">{{ sortName }}</div>
      <van-action-sheet
        v-model="show"
        :actions="actions"
        cancel-text="取消"
        close-on-click-action
        @cancel="onCancel"
        @select="onSelect($event)"
        @open="open"
        @close="close"
      />
    </div>
    <div class="official">
      <!-- 已發布帖子 -->
      <van-list
        v-model="listInit.loading"
        :finished="listInit.finished"
        finished-text="没有更多了"
        :immediate-check="false"
        @load="onLoad"
      >
        <card v-for="item in topicsList" :key="item.id" :cardData="item"></card>
      </van-list>
    </div>
  </van-pull-refresh>
</template>

<script>
import get from '@/api/get';
import card from '../../card';
import { Toast } from 'vant';
export default {
  name: 'official',
  components: { card },
  data() {
    return {
      name: 'official',
      listInit: {
        loading: false,
        finished: false,
        pageNo: 1,
        pageSize: 10
      },
      isLoading: false,
      show: false,
      actions: [{ name: '最新回复' }, { name: '最新發布' }, { name: '热门' }],
      sortType: 0,
      sortName: '最新回复'
    };
  },
  props: ['topicsList', 'typeName', 'tops'],
  mounted() {
    // this.init();
  },
  methods: {
    detailClick(id) {
      this.$store.state.anchorFlag = false;
      this.$router.push({
        path: '../topicPage/?topicId=' + id + '&isGame=true'
      });
    },
    init() {
      this.listInit.pageNo = 1;
      this.listInit.refresh = true;
      this.$emit('tabClick', 2, this.typeName, this.listInit);
    },
    // 下拉加载
    onLoad() {
      let _this = this;
      this.listInit.refresh = false;
      this.listInit.sortType = this.sortType;
      // this.listInit.onLoadFlag = true;
      this.listInit.pageNo++;
      setTimeout(() => {
        this.$emit(
          'tabClick',
          2,
          this.typeName,
          this.listInit,
          function (newList) {
            // 加载状态结束
            _this.listInit.loading = false;
            // 数据全部加载完成
            if (newList.length < 10) {
              _this.listInit.finished = true;
              _this.listInit.pageNo--;
            }
          }
        );
      }, 1000);
    },
    vueTouch(text, e) {
      this.listInit.finished = false;
      this.listInit.loading = true;
      setTimeout(() => {
        this.onLoad();
      }, 1000);
    },
    // 下拉刷新
    onRefresh() {
      var _this = this;
      _this.listInit.pageNo = 1;
      setTimeout(() => {
        this.isLoading = false;
        this.$emit('tabClick', 2, this.typeName, this.listInit, '', true);
        // Toast('刷新成功');
      }, 1000);
    },
    onCancel() {
      if (this.$store.state.system == 'iphone') {
        window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=0';
      }
      Toast('取消');
    },
    open() {
      if (this.$store.state.system == 'iphone') {
        window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=1';
      }
    },
    close() {
      if (this.$store.state.system == 'iphone') {
        window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=0';
      }
    },
    onSelect(item) {
      if (item.name == '最新回复')
        (this.sortType = 0), (this.sortName = item.name);
      if (item.name == '热门') (this.sortType = 2), (this.sortName = item.name);
      if (item.name == '最新發布')
        (this.sortType = 4), (this.sortName = item.name);
      this.listInit.sortType = this.sortType;
      this.init();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
